import { VehicleBuyInStatus } from "@/api-schema-enums";
import { VEHICLE_BUY_IN_STATUS_TRANSLATIONS } from "@/components/vehicle-buy-in/vehicle-buy-in-status-translations";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

const VEHICLE_BUY_IN_STATUS_OPTIONS: FilterData["options"] = Object.values(VehicleBuyInStatus).map((status) => ({
  id: status,
  name: VEHICLE_BUY_IN_STATUS_TRANSLATIONS[status],
}));

export class VehicleBuyInStatusFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id = "status";
  readonly labelSingular = "common:Status";
  readonly labelPlural = "common:Status";
  readonly placeholder = "fab:SelectVehicleBuyInStatus";
  readonly searchPlaceholder = "fab:SearchVehicleBuyInStatus";
  readonly emptyText = "fab:NoVehicleBuyInStatusFound";
  body = {};
  parameters = {};

  getData(): FilterData {
    return { options: VEHICLE_BUY_IN_STATUS_OPTIONS, isLoading: false, error: null };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
